
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as _404vIElQJxKVP2kkBFRRuAZAVUrBEVhUcbZeDsKmx7oPRQMeta } from "/Users/rice/xtable-pos-v3/pages/404.vue?macro=true";
import { default as indexW7nelHvPuoNHL9inmLjoq5jU474NViCYegB_45yCgHpcAMeta } from "/Users/rice/xtable-pos-v3/pages/index.vue?macro=true";
import { default as logingoT_45bU8JTUFLjcB_45nLPD70F_45xm_45q2xE_C4qzkxiKt_IMeta } from "/Users/rice/xtable-pos-v3/pages/login.vue?macro=true";
import { default as signupj0QrxSgDIS9brvnTYbCAJJwIBAT72SiQ9_45VwMgac2VwMeta } from "/Users/rice/xtable-pos-v3/pages/signup.vue?macro=true";
import { default as uploadRW_DLMyq2qejpQyiZKTeb_45mRKd0gU4XHltSY1xEyA_sMeta } from "/Users/rice/xtable-pos-v3/pages/upload.vue?macro=true";
import { default as expiredaDDfrhf1Dd_QWQz1G6iNKql7_457BCcrJmN4XS8I0RnqkMeta } from "/Users/rice/xtable-pos-v3/pages/expired.vue?macro=true";
import { default as notallowedrBzZzDI94Z1R8JKJkKBfXTZWwdjgExaV8iJ5AnuN6FUMeta } from "/Users/rice/xtable-pos-v3/pages/notallowed.vue?macro=true";
import { default as sentry_45testUw8SguJyrRVjuYhs14Q5M6ZWd6MOFAw8Y0lGEYJSkq4Meta } from "/Users/rice/xtable-pos-v3/pages/sentry-test.vue?macro=true";
import { default as unauthorizedJVi0Okp237FdcdWr2EmqnvVw2GMGrs3lI9XC2661dQsMeta } from "/Users/rice/xtable-pos-v3/pages/unauthorized.vue?macro=true";
import { default as indexpBJprsdg3UOojMmoW4MYnVT5XJgkg3zQG9wzTQp1nqUMeta } from "/Users/rice/xtable-pos-v3/pages/expenses/index.vue?macro=true";
import { default as forgot_45passwordflkC247rx09Q7EjV_fwbXBIukqKssc8_455OWqpW4j2egMeta } from "/Users/rice/xtable-pos-v3/pages/forgot-password.vue?macro=true";
import { default as select_45run_45modeE4xTPM7DRSqLcXCfAp30sJwA3zmWow7dCc8ufte0U_MMeta } from "/Users/rice/xtable-pos-v3/pages/select-run-mode.vue?macro=true";
import { default as login_45with_45tokenB7XK7j_4fv7uuBQ1722IO0mnhOikAvZHQZA1ZJ1YoUUMeta } from "/Users/rice/xtable-pos-v3/pages/login-with-token.vue?macro=true";
import { default as change_45receipt_45dateCZql_LLCDtDI8m0rA_q_45_rNqESRls1uUzQOnSM2_3hMMeta } from "/Users/rice/xtable-pos-v3/pages/change-receipt-date.vue?macro=true";
import { default as transactionNTmgL7091_45z_45kkdceI5_QvVQcVC_45hwK_Oo5MyPLxtNEMeta } from "/Users/rice/xtable-pos-v3/pages/expenses/transaction.vue?macro=true";
import { default as indexhJJScOWyTqoMHe5W1Vbv6LnkEJuL2VrWrFzMjMl7PPoMeta } from "/Users/rice/xtable-pos-v3/modules/check-printer/pages/index.vue?macro=true";
import { default as indexksccpEODlZnQCRwhsJR7Ez12ZvJYmuP6iQEMvGZQ0BoMeta } from "/Users/rice/xtable-pos-v3/modules/dashboard/pages/dashboard/index.vue?macro=true";
import { default as receiptspokTl7e4Rue3NGFe34sA2F0NzLG4gBfQn_Gsa7_4M44Meta } from "/Users/rice/xtable-pos-v3/modules/dashboard/pages/dashboard/receipts.vue?macro=true";
import { default as livekJxtYVar2ls7ta2blxKbkooN83O_y5zFPXWDa0f7qrQMeta } from "/Users/rice/xtable-pos-v3/modules/dashboard/pages/dashboard/live.vue?macro=true";
import { default as productsh0KD80LBQ8W6uCvQypPjB4Ri5MFiopg_45RJageQe3eT4Meta } from "/Users/rice/xtable-pos-v3/modules/dashboard/pages/dashboard/products.vue?macro=true";
import { default as voided_45itemswVvCHVDHCb8DLD1w6Np2LuavwUkQ_45v5j3IMlhZeDQ3QMeta } from "/Users/rice/xtable-pos-v3/modules/dashboard/pages/dashboard/voided-items.vue?macro=true";
import { default as check_45onlineZPZChl2Lh7X6Xd6tgWjcFuGDFyHWBNxrxJagW8RgiisMeta } from "/Users/rice/xtable-pos-v3/modules/dashboard/pages/dashboard/check-online.vue?macro=true";
import { default as closenhFBM77RHs20UQhCkHbXtdEVdNmCpe_45vEZzetMN3QTsMeta } from "/Users/rice/xtable-pos-v3/modules/dashboard/pages/dashboard/close.vue?macro=true";
import { default as paymentsBxjBNey5F0QPcV_CVvQxbPh8oHsiJvZiY6nwj3T9AKwMeta } from "/Users/rice/xtable-pos-v3/modules/dashboard/pages/dashboard/payments.vue?macro=true";
import { default as dashboardaUwplqjy6oBdn3U9aga_1bjzogKpYU998oHNKOkhE5QMeta } from "/Users/rice/xtable-pos-v3/modules/dashboard/pages/dashboard.vue?macro=true";
import { default as logsPZQHst6TPQXo_453xFNHgYSa7yFkGvGaUuoNF15Ls0P_45YMeta } from "/Users/rice/xtable-pos-v3/modules/history/pages/logs.vue?macro=true";
import { default as listyIAFo6alxnj0sm7LkCoTam9RXL9XfrpeNPyOobWVDv4Meta } from "/Users/rice/xtable-pos-v3/modules/inventory/pages/inventory/list.vue?macro=true";
import { default as insertAvOXWG4HMFUzRsOY6PXVfuSpN_455KaXuGKxy8tqpJuRAMeta } from "/Users/rice/xtable-pos-v3/modules/inventory/pages/inventory/insert.vue?macro=true";
import { default as add68_kaH3GupgKBRRmHnw2QdDvCLmsJypVTdMNPJA4arMMeta } from "/Users/rice/xtable-pos-v3/modules/inventory/pages/inventory/add.vue?macro=true";
import { default as editZh_45AvHsgy0R4jp3haB9HKbIYYiZVgpAo4C61OCzr3CUMeta } from "/Users/rice/xtable-pos-v3/modules/inventory/pages/inventory/edit.vue?macro=true";
import { default as detail2jbPRL2J_wcXLcGvPE5TUAJ02BFyVbAV8DIw1Acy_mYMeta } from "/Users/rice/xtable-pos-v3/modules/inventory/pages/inventory/detail.vue?macro=true";
import { default as reportWdyJxy6fJCGaEqDLhsvliujTcVn2gKebgMDeWnTm9pcMeta } from "/Users/rice/xtable-pos-v3/modules/inventory/pages/inventory/report.vue?macro=true";
import { default as formula_45itemsYXHo7dwt1KWTASASYpeg0WbgQQfvIlYxKfVMfOvk8e8Meta } from "/Users/rice/xtable-pos-v3/modules/inventory/pages/inventory/formula-items.vue?macro=true";
import { default as formula_45toppingsQfKBVwOIURexIE0_n6NJBatdvqZCwqpjTQU5K0_45oVXoMeta } from "/Users/rice/xtable-pos-v3/modules/inventory/pages/inventory/formula-toppings.vue?macro=true";
import { default as formula_45stocks_45QdvDDv0xSolTjGe6URUeuSB8pFsMrWaWwnTUuWpThEMeta } from "/Users/rice/xtable-pos-v3/modules/inventory/pages/inventory/formula-stocks.vue?macro=true";
import { default as historyG0IvfZ5D3Hy_45_454esQOSMrgH15RAWYZtemxukmQDytJUMeta } from "/Users/rice/xtable-pos-v3/modules/inventory/pages/inventory/history.vue?macro=true";
import { default as verifypLRj5EFpjpPT4El6j6lmzJQBKXMgG9dbvyVumP2xT30Meta } from "/Users/rice/xtable-pos-v3/modules/inventory/pages/inventory/verify.vue?macro=true";
import { default as inventorypj0k0L8OpCu9seAbiGS3__45HUocWf1tnRfsfv07k3BCMMeta } from "/Users/rice/xtable-pos-v3/modules/inventory/pages/inventory.vue?macro=true";
import { default as index71JQDQySfnN0dx1xT_CRrvn9wR2KRQYiolEaRk6JJoIMeta } from "/Users/rice/xtable-pos-v3/modules/pos/pages/index.vue?macro=true";
import { default as carthsFm5kulmX_45aFHu2pQUyK4KjsU9dP_UOFl6n5BFTj9YMeta } from "/Users/rice/xtable-pos-v3/modules/pos/pages/cart.vue?macro=true";
import { default as indexQnssk0zymGH9Wg4K_Z7X7zcbDRGlebEtBywkO5KoeCIMeta } from "/Users/rice/xtable-pos-v3/modules/product/pages/menu/index.vue?macro=true";
import { default as overviewxvQ9_45A7okYtOfqTBhQvWvtislFRW00dj5DjODZ1wGxMMeta } from "/Users/rice/xtable-pos-v3/modules/product/pages/menu/overview.vue?macro=true";
import { default as export8bjvrAUuOz6ygAKFvr3m05D_45939mGo8IFOwBakKRtrcMeta } from "/Users/rice/xtable-pos-v3/modules/product/pages/menu/export.vue?macro=true";
import { default as groups1qUzg0D9fGG8gtbqEgnGfIPrbNKBzXjMBi3BG49uxqIMeta } from "/Users/rice/xtable-pos-v3/modules/product/pages/menu/groups.vue?macro=true";
import { default as items4HRSdhJ6Cx234AupryhrmGWm6yXB4l6RBHq2ZmsdCFsMeta } from "/Users/rice/xtable-pos-v3/modules/product/pages/menu/items.vue?macro=true";
import { default as addonyS6gM14MYZS29WGyoYoEir5xAYY9wre8DljG9kBNX8wMeta } from "/Users/rice/xtable-pos-v3/modules/product/pages/menu/addon.vue?macro=true";
import { default as qrcodeAgB3h_453Il1jMC3ySA31k5Uk8IwROFmT9hEGWVjsXQS4Meta } from "/Users/rice/xtable-pos-v3/modules/product/pages/menu/qrcode.vue?macro=true";
import { default as tagVs5boJmSA1wMGx_iyUkgHUYQAZmuBQuMce6i_9v_45l2cMeta } from "/Users/rice/xtable-pos-v3/modules/product/pages/menu/tag.vue?macro=true";
import { default as categoriesIMA5T_45ziqM3vnVvTSBo987K6pRfnx82X8Jc8CFM3_45PIMeta } from "/Users/rice/xtable-pos-v3/modules/product/pages/menu/categories.vue?macro=true";
import { default as channelXEq0vyunJgwMw3ak6pMohfL6hRLf3b6kcGbMQ6sU9YEMeta } from "/Users/rice/xtable-pos-v3/modules/product/pages/menu/channel.vue?macro=true";
import { default as printernZDRB7u28R6skdPz_45vzoSLcMYkjTSEBUrzJjqurYjxsMeta } from "/Users/rice/xtable-pos-v3/modules/product/pages/menu/printer.vue?macro=true";
import { default as groups_batchSxn4nMig0HX_45ujt5JK1IFgrx4Z8_45ZXO8MCsUrRffx_45cMeta } from "/Users/rice/xtable-pos-v3/modules/product/pages/menu/groups_batch.vue?macro=true";
import { default as items_batch4N5iz7FHhc_45_jRINoZtPLkGY1DSKfE4Nc8LehLcXUaEMeta } from "/Users/rice/xtable-pos-v3/modules/product/pages/menu/items_batch.vue?macro=true";
import { default as items_batch2JJfkYTdlSAd_451zmIcynvRJS66XlT2klbCqp8OvqLSTsMeta } from "/Users/rice/xtable-pos-v3/modules/product/pages/menu/items_batch2.vue?macro=true";
import { default as openMenuuN9erZD7q_45A9wfs9yJG3RYKN6Q3fpLO91Roa_45Qy_45y7YMeta } from "/Users/rice/xtable-pos-v3/modules/product/pages/menu/openMenu.vue?macro=true";
import { default as manage_45expenseQE7yNn3qYmTE23ITTil3czKeQsDj_45zzSGBzQtq7L1UMMeta } from "/Users/rice/xtable-pos-v3/modules/product/pages/menu/manage-expense.vue?macro=true";
import { default as expense_45transaction7EH54aydb_45fHvBK8EEkhwOPp0VJi12HcLzykiKRk7RgMeta } from "/Users/rice/xtable-pos-v3/modules/product/pages/menu/expense-transaction.vue?macro=true";
import { default as menuhgmDTTSTK9xlSrBiEGBKDLhIQclnVYVO0wIMosSgmzIMeta } from "/Users/rice/xtable-pos-v3/modules/product/pages/menu.vue?macro=true";
import { default as index708WQe6wBgumgJaW4qDy_45H9Fw9PVZ83caf2pJYw0WSkMeta } from "/Users/rice/xtable-pos-v3/modules/reports/pages/index.vue?macro=true";
import { default as summary_45dailyZ9L9UJnT8xMBXymnQX2ytfKXyIO1s1nYBmu2ty7qV5MMeta } from "/Users/rice/xtable-pos-v3/modules/reports/pages/summary-daily.vue?macro=true";
import { default as receiptsN78Pnhk4GBzGi_8z_tbZPwgTdYVCS8tmZsRv1Za4cbEMeta } from "/Users/rice/xtable-pos-v3/modules/reports/pages/receipts.vue?macro=true";
import { default as receipts_45by_45datev3FMn83z0063U3Vd14ukaOW23YXVem_2_45FtaPOUlhqUMeta } from "/Users/rice/xtable-pos-v3/modules/reports/pages/receipts-by-date.vue?macro=true";
import { default as voided_45billsYJh9Anv7oLgbSriYSDzUIdDTBIKwkOCHNHZDNiZEesgMeta } from "/Users/rice/xtable-pos-v3/modules/reports/pages/voided-bills.vue?macro=true";
import { default as productsDqdQ2wX46ycvWk_45muRXp_nDLVbQInWv2d6jrU9grnakMeta } from "/Users/rice/xtable-pos-v3/modules/reports/pages/products.vue?macro=true";
import { default as products_45dailyDdIhgMirz7iPqM5mDhGD08Puo6Gh6meJm2_wWDfuf_kMeta } from "/Users/rice/xtable-pos-v3/modules/reports/pages/products-daily.vue?macro=true";
import { default as transaction_45by_45hourao2_Ddn32PehdgF1vn7DQbo3s3Cjt9FTC0FdQS1kuwEMeta } from "/Users/rice/xtable-pos-v3/modules/reports/pages/transaction-by-hour.vue?macro=true";
import { default as products_45voidedcmLWpbsD28cAN_8rvfb6h9RxcLeFC4O8xby6_45Tap2bwMeta } from "/Users/rice/xtable-pos-v3/modules/reports/pages/products-voided.vue?macro=true";
import { default as change_45products_45pricegL15_457Qtn2ZE3O3A3BKNAP7j8m0_45sp5ghC1F0XXQsToMeta } from "/Users/rice/xtable-pos-v3/modules/reports/pages/change-products-price.vue?macro=true";
import { default as products_45open_45menuAav4eQnGnh9NmM0rhFh_nn5BzJdaORXwJENA_4ztd_458Meta } from "/Users/rice/xtable-pos-v3/modules/reports/pages/products-open-menu.vue?macro=true";
import { default as activity_45log05YwFudnK5MsRGLM5IBLeMtfrTt7BQpEEgoyCOoNWdwMeta } from "/Users/rice/xtable-pos-v3/modules/reports/pages/activity-log.vue?macro=true";
import { default as sales_45by_45employeeeX27Pka_qp0NvnObxsD_45rKUBgLpy5mqnkEvzcaHgEYEMeta } from "/Users/rice/xtable-pos-v3/modules/reports/pages/sales-by-employee.vue?macro=true";
import { default as expenseLBnWZcES_NoYR58snCOFlZ2m_4572iFrJ_Vm8v5WZbi14Meta } from "/Users/rice/xtable-pos-v3/modules/reports/pages/expense.vue?macro=true";
import { default as summary_45by_45table_45zoneccPJE1jEhqTB_UH9xg0OrkAlbacPg9jKs6uY3kkCUF4Meta } from "/Users/rice/xtable-pos-v3/modules/reports/pages/summary-by-table-zone.vue?macro=true";
import { default as summary_45order_45detailEkgoVWi_45iXpYDIW6Vu4cq0hIxmsd63p3b72lKtWj1SoMeta } from "/Users/rice/xtable-pos-v3/modules/reports/pages/summary-order-detail.vue?macro=true";
import { default as indexrDD2mFOQiEOqmfIBjUZGucccrSWJgrWJ6qLsa6VftyUMeta } from "/Users/rice/xtable-pos-v3/modules/setting/pages/settings/index.vue?macro=true";
import { default as tablesNFL4QCYc4V9ysNlk9pTdBoLh151VBFXDzrt65Xf4FewMeta } from "/Users/rice/xtable-pos-v3/modules/setting/pages/settings/tables.vue?macro=true";
import { default as channels7pIG6uXiRe_45NWvpL7B78aN32RfmCfW6a07fbD_45ARIC4Meta } from "/Users/rice/xtable-pos-v3/modules/setting/pages/settings/channels.vue?macro=true";
import { default as employees2ePeM2DEwZnmdVN5j_45_n_yLFojbVkXWZ647o19tbU_cMeta } from "/Users/rice/xtable-pos-v3/modules/setting/pages/settings/employees.vue?macro=true";
import { default as paymentsEtPfLm_WKPPU4_45xY_trcreXyo6_I0mE139qy_lz9H0cMeta } from "/Users/rice/xtable-pos-v3/modules/setting/pages/settings/payments.vue?macro=true";
import { default as printersJahAgsr2lzoANQEu_45xJiafN1zhnX8RgTb_45Er2sRx30kMeta } from "/Users/rice/xtable-pos-v3/modules/setting/pages/settings/printers.vue?macro=true";
import { default as forward_45zonekq4pEE_45s0XyqHRl_LNdIFy41jnyQQJUVcbrRoHx_45m1cMeta } from "/Users/rice/xtable-pos-v3/modules/setting/pages/settings/forward-zone.vue?macro=true";
import { default as mobile_45connectEqdi3Xb5vc5uu7xQrmS2aRqtoRLBb63_45qmf7UZ9z1nMMeta } from "/Users/rice/xtable-pos-v3/modules/setting/pages/settings/mobile-connect.vue?macro=true";
import { default as invite_45userOK5yIKmbpvEgBkDPagQX7fCepvrIR6WcMhLT_Sxc11kMeta } from "/Users/rice/xtable-pos-v3/modules/setting/pages/settings/invite-user.vue?macro=true";
import { default as receipt_45tagsTbWCWrRCPi8OD_A20jKoAJE5yk8ulf_45nkt5MYGfdDy0Meta } from "/Users/rice/xtable-pos-v3/modules/setting/pages/settings/receipt-tags.vue?macro=true";
import { default as computer_45nameqDNZMa3NvIpdWPIa_c1Mbezp9jj2r18r7ZoFGYP38oEMeta } from "/Users/rice/xtable-pos-v3/modules/setting/pages/settings/computer-name.vue?macro=true";
import { default as indexaBbERBgDdTjlr2ULbCd_45Za5QCW7mbK4XykoseGLEuwsMeta } from "/Users/rice/xtable-pos-v3/modules/setting/pages/index.vue?macro=true";
import { default as indexUB8WfpKXwZE1qvjMgXxaksguWtOLV1_45YmP5auE3NGg8Meta } from "/Users/rice/xtable-pos-v3/modules/topup/pages/topup/index.vue?macro=true";
import { default as promptpaydctJvWSfKQZZP8aibzIbLBqwmWy7S4xk_459P8kEKvcZ4Meta } from "/Users/rice/xtable-pos-v3/modules/topup/pages/topup/promptpay.vue?macro=true";
import { default as taxInvoiceInfouoQEivBUtw_45z2BWCV5C9A5DOpk34jZ7Wphj9xGiwQWMMeta } from "/Users/rice/xtable-pos-v3/modules/topup/pages/topup/taxInvoiceInfo.vue?macro=true";
import { default as topuptbOi_B4vLyobiVbotYK_8gx020mF8OsmXAqdOzjXTmQMeta } from "/Users/rice/xtable-pos-v3/modules/topup/pages/topup.vue?macro=true";
export default [
  {
    name: "404",
    path: "/404",
    component: () => import("/Users/rice/xtable-pos-v3/pages/404.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexW7nelHvPuoNHL9inmLjoq5jU474NViCYegB_45yCgHpcAMeta || {},
    component: () => import("/Users/rice/xtable-pos-v3/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: logingoT_45bU8JTUFLjcB_45nLPD70F_45xm_45q2xE_C4qzkxiKt_IMeta || {},
    component: () => import("/Users/rice/xtable-pos-v3/pages/login.vue")
  },
  {
    name: "signup",
    path: "/signup",
    meta: signupj0QrxSgDIS9brvnTYbCAJJwIBAT72SiQ9_45VwMgac2VwMeta || {},
    component: () => import("/Users/rice/xtable-pos-v3/pages/signup.vue")
  },
  {
    name: "upload",
    path: "/upload",
    meta: uploadRW_DLMyq2qejpQyiZKTeb_45mRKd0gU4XHltSY1xEyA_sMeta || {},
    component: () => import("/Users/rice/xtable-pos-v3/pages/upload.vue")
  },
  {
    name: "expired",
    path: "/expired",
    meta: expiredaDDfrhf1Dd_QWQz1G6iNKql7_457BCcrJmN4XS8I0RnqkMeta || {},
    component: () => import("/Users/rice/xtable-pos-v3/pages/expired.vue")
  },
  {
    name: "notallowed",
    path: "/notallowed",
    meta: notallowedrBzZzDI94Z1R8JKJkKBfXTZWwdjgExaV8iJ5AnuN6FUMeta || {},
    component: () => import("/Users/rice/xtable-pos-v3/pages/notallowed.vue")
  },
  {
    name: "sentry-test",
    path: "/sentry-test",
    meta: sentry_45testUw8SguJyrRVjuYhs14Q5M6ZWd6MOFAw8Y0lGEYJSkq4Meta || {},
    component: () => import("/Users/rice/xtable-pos-v3/pages/sentry-test.vue")
  },
  {
    name: "unauthorized",
    path: "/unauthorized",
    component: () => import("/Users/rice/xtable-pos-v3/pages/unauthorized.vue")
  },
  {
    name: "expenses",
    path: "/expenses",
    component: () => import("/Users/rice/xtable-pos-v3/pages/expenses/index.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: forgot_45passwordflkC247rx09Q7EjV_fwbXBIukqKssc8_455OWqpW4j2egMeta || {},
    component: () => import("/Users/rice/xtable-pos-v3/pages/forgot-password.vue")
  },
  {
    name: "select-run-mode",
    path: "/select-run-mode",
    component: () => import("/Users/rice/xtable-pos-v3/pages/select-run-mode.vue")
  },
  {
    name: "login-with-token",
    path: "/login-with-token",
    meta: login_45with_45tokenB7XK7j_4fv7uuBQ1722IO0mnhOikAvZHQZA1ZJ1YoUUMeta || {},
    component: () => import("/Users/rice/xtable-pos-v3/pages/login-with-token.vue")
  },
  {
    name: "change-receipt-date",
    path: "/change-receipt-date",
    meta: change_45receipt_45dateCZql_LLCDtDI8m0rA_q_45_rNqESRls1uUzQOnSM2_3hMMeta || {},
    component: () => import("/Users/rice/xtable-pos-v3/pages/change-receipt-date.vue")
  },
  {
    name: "expenses-transaction",
    path: "/expenses/transaction",
    component: () => import("/Users/rice/xtable-pos-v3/pages/expenses/transaction.vue")
  },
  {
    name: "check-printer",
    path: "/check-printer",
    component: () => import("/Users/rice/xtable-pos-v3/modules/check-printer/pages/index.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    component: () => import("/Users/rice/xtable-pos-v3/modules/dashboard/pages/dashboard.vue"),
    children: [
  {
    name: "",
    path: "",
    component: () => import("/Users/rice/xtable-pos-v3/modules/dashboard/pages/dashboard/index.vue")
  },
  {
    name: "receipts",
    path: "receipts",
    component: () => import("/Users/rice/xtable-pos-v3/modules/dashboard/pages/dashboard/receipts.vue")
  },
  {
    name: "live",
    path: "live",
    component: () => import("/Users/rice/xtable-pos-v3/modules/dashboard/pages/dashboard/live.vue")
  },
  {
    name: "products",
    path: "products",
    component: () => import("/Users/rice/xtable-pos-v3/modules/dashboard/pages/dashboard/products.vue")
  },
  {
    name: "voided-items",
    path: "voided-items",
    component: () => import("/Users/rice/xtable-pos-v3/modules/dashboard/pages/dashboard/voided-items.vue")
  },
  {
    name: "check-online",
    path: "check-online",
    component: () => import("/Users/rice/xtable-pos-v3/modules/dashboard/pages/dashboard/check-online.vue")
  },
  {
    name: "close",
    path: "/dashboard/close",
    component: () => import("/Users/rice/xtable-pos-v3/modules/dashboard/pages/dashboard/close.vue")
  },
  {
    name: "dashboard-payments",
    path: "/dashboard/payments",
    component: () => import("/Users/rice/xtable-pos-v3/modules/dashboard/pages/dashboard/payments.vue")
  }
]
  },
  {
    name: "history",
    path: "/logs",
    component: () => import("/Users/rice/xtable-pos-v3/modules/history/pages/logs.vue")
  },
  {
    name: "inventory",
    path: "/inventory",
    component: () => import("/Users/rice/xtable-pos-v3/modules/inventory/pages/inventory.vue"),
    children: [
  {
    name: "list",
    path: "list",
    component: () => import("/Users/rice/xtable-pos-v3/modules/inventory/pages/inventory/list.vue")
  },
  {
    name: "insert",
    path: "insert",
    component: () => import("/Users/rice/xtable-pos-v3/modules/inventory/pages/inventory/insert.vue")
  },
  {
    name: "add",
    path: "add",
    component: () => import("/Users/rice/xtable-pos-v3/modules/inventory/pages/inventory/add.vue")
  },
  {
    name: "edit",
    path: "edit",
    component: () => import("/Users/rice/xtable-pos-v3/modules/inventory/pages/inventory/edit.vue")
  },
  {
    name: "detail",
    path: "detail",
    component: () => import("/Users/rice/xtable-pos-v3/modules/inventory/pages/inventory/detail.vue")
  },
  {
    name: "inventory-report",
    path: "report",
    component: () => import("/Users/rice/xtable-pos-v3/modules/inventory/pages/inventory/report.vue")
  },
  {
    name: "inventory-formula-items",
    path: "formula-items",
    component: () => import("/Users/rice/xtable-pos-v3/modules/inventory/pages/inventory/formula-items.vue")
  },
  {
    name: "inventory-formula-toppings",
    path: "formula-toppings",
    component: () => import("/Users/rice/xtable-pos-v3/modules/inventory/pages/inventory/formula-toppings.vue")
  },
  {
    name: "inventory-formula-stocks",
    path: "formula-stocks",
    component: () => import("/Users/rice/xtable-pos-v3/modules/inventory/pages/inventory/formula-stocks.vue")
  },
  {
    name: "inventory-history",
    path: "history",
    component: () => import("/Users/rice/xtable-pos-v3/modules/inventory/pages/inventory/history.vue")
  },
  {
    name: "inventory-verify",
    path: "verify",
    component: () => import("/Users/rice/xtable-pos-v3/modules/inventory/pages/inventory/verify.vue")
  }
]
  },
  {
    name: "pos",
    path: "/pos",
    component: () => import("/Users/rice/xtable-pos-v3/modules/pos/pages/index.vue")
  },
  {
    name: "cart",
    path: "/pos/cart",
    component: () => import("/Users/rice/xtable-pos-v3/modules/pos/pages/cart.vue")
  },
  {
    name: "menu",
    path: "/menu",
    component: () => import("/Users/rice/xtable-pos-v3/modules/product/pages/menu.vue"),
    children: [
  {
    name: "",
    path: "",
    component: () => import("/Users/rice/xtable-pos-v3/modules/product/pages/menu/index.vue")
  },
  {
    name: "overview",
    path: "overview",
    component: () => import("/Users/rice/xtable-pos-v3/modules/product/pages/menu/overview.vue")
  },
  {
    name: "export",
    path: "export",
    component: () => import("/Users/rice/xtable-pos-v3/modules/product/pages/menu/export.vue")
  },
  {
    name: "groups",
    path: "groups",
    component: () => import("/Users/rice/xtable-pos-v3/modules/product/pages/menu/groups.vue")
  },
  {
    name: "items",
    path: "items",
    component: () => import("/Users/rice/xtable-pos-v3/modules/product/pages/menu/items.vue")
  },
  {
    name: "addon",
    path: "addon",
    component: () => import("/Users/rice/xtable-pos-v3/modules/product/pages/menu/addon.vue")
  },
  {
    name: "qrcode",
    path: "qrcode",
    component: () => import("/Users/rice/xtable-pos-v3/modules/product/pages/menu/qrcode.vue")
  },
  {
    name: "tag",
    path: "tag",
    component: () => import("/Users/rice/xtable-pos-v3/modules/product/pages/menu/tag.vue")
  },
  {
    name: "category",
    path: "categories",
    component: () => import("/Users/rice/xtable-pos-v3/modules/product/pages/menu/categories.vue")
  },
  {
    name: "channel",
    path: "channel",
    component: () => import("/Users/rice/xtable-pos-v3/modules/product/pages/menu/channel.vue")
  },
  {
    name: "printer",
    path: "printer",
    component: () => import("/Users/rice/xtable-pos-v3/modules/product/pages/menu/printer.vue")
  },
  {
    name: "groups_batch",
    path: "groups_batch",
    component: () => import("/Users/rice/xtable-pos-v3/modules/product/pages/menu/groups_batch.vue")
  },
  {
    name: "items_batch",
    path: "items_batch",
    component: () => import("/Users/rice/xtable-pos-v3/modules/product/pages/menu/items_batch.vue")
  },
  {
    name: "items_batch2",
    path: "items_batch2",
    component: () => import("/Users/rice/xtable-pos-v3/modules/product/pages/menu/items_batch2.vue")
  },
  {
    name: "openMenu",
    path: "openMenu",
    component: () => import("/Users/rice/xtable-pos-v3/modules/product/pages/menu/openMenu.vue")
  },
  {
    name: "manage-expense",
    path: "manage-expense",
    component: () => import("/Users/rice/xtable-pos-v3/modules/product/pages/menu/manage-expense.vue")
  },
  {
    name: "expense-transaction",
    path: "expense-transaction",
    component: () => import("/Users/rice/xtable-pos-v3/modules/product/pages/menu/expense-transaction.vue")
  }
]
  },
  {
    name: "reports",
    path: "/reports",
    component: () => import("/Users/rice/xtable-pos-v3/modules/reports/pages/index.vue")
  },
  {
    name: "summary-daily",
    path: "/reports/summary-daily",
    component: () => import("/Users/rice/xtable-pos-v3/modules/reports/pages/summary-daily.vue")
  },
  {
    name: "report-receipts",
    path: "/reports/receipts",
    component: () => import("/Users/rice/xtable-pos-v3/modules/reports/pages/receipts.vue")
  },
  {
    name: "report-receipts-by-date",
    path: "/reports/receipts-by-date",
    component: () => import("/Users/rice/xtable-pos-v3/modules/reports/pages/receipts-by-date.vue")
  },
  {
    name: "report-voided-bills",
    path: "/reports/voided-bills",
    component: () => import("/Users/rice/xtable-pos-v3/modules/reports/pages/voided-bills.vue")
  },
  {
    name: "report-products",
    path: "/reports/products",
    component: () => import("/Users/rice/xtable-pos-v3/modules/reports/pages/products.vue")
  },
  {
    name: "products-daily",
    path: "/reports/products-daily",
    component: () => import("/Users/rice/xtable-pos-v3/modules/reports/pages/products-daily.vue")
  },
  {
    name: "transaction-by-hour",
    path: "/reports/transaction-by-hour",
    component: () => import("/Users/rice/xtable-pos-v3/modules/reports/pages/transaction-by-hour.vue")
  },
  {
    name: "products-voided",
    path: "/reports/products-voided",
    component: () => import("/Users/rice/xtable-pos-v3/modules/reports/pages/products-voided.vue")
  },
  {
    name: "change-products-price",
    path: "/reports/change-products-price",
    component: () => import("/Users/rice/xtable-pos-v3/modules/reports/pages/change-products-price.vue")
  },
  {
    name: "products-open-menu",
    path: "/reports/products-open-menu",
    component: () => import("/Users/rice/xtable-pos-v3/modules/reports/pages/products-open-menu.vue")
  },
  {
    name: "activity-log",
    path: "/reports/activity-log",
    component: () => import("/Users/rice/xtable-pos-v3/modules/reports/pages/activity-log.vue")
  },
  {
    name: "sales-by-employee",
    path: "/reports/sales-by-employee",
    component: () => import("/Users/rice/xtable-pos-v3/modules/reports/pages/sales-by-employee.vue")
  },
  {
    name: "expense",
    path: "/reports/expense",
    component: () => import("/Users/rice/xtable-pos-v3/modules/reports/pages/expense.vue")
  },
  {
    name: "summary-by-table-zone",
    path: "/reports/summary-by-table-zone",
    component: () => import("/Users/rice/xtable-pos-v3/modules/reports/pages/summary-by-table-zone.vue")
  },
  {
    name: "summary-order-detail",
    path: "/reports/summary-order-detail",
    component: () => import("/Users/rice/xtable-pos-v3/modules/reports/pages/summary-order-detail.vue")
  },
  {
    name: "setting",
    path: "/settings",
    component: () => import("/Users/rice/xtable-pos-v3/modules/setting/pages/index.vue"),
    children: [
  {
    name: "",
    path: "",
    component: () => import("/Users/rice/xtable-pos-v3/modules/setting/pages/settings/index.vue")
  },
  {
    name: "tables",
    path: "tables",
    component: () => import("/Users/rice/xtable-pos-v3/modules/setting/pages/settings/tables.vue")
  },
  {
    name: "channels",
    path: "channels",
    component: () => import("/Users/rice/xtable-pos-v3/modules/setting/pages/settings/channels.vue")
  },
  {
    name: "employees",
    path: "employees",
    component: () => import("/Users/rice/xtable-pos-v3/modules/setting/pages/settings/employees.vue")
  },
  {
    name: "payments",
    path: "payments",
    component: () => import("/Users/rice/xtable-pos-v3/modules/setting/pages/settings/payments.vue")
  },
  {
    name: "printers",
    path: "printers",
    component: () => import("/Users/rice/xtable-pos-v3/modules/setting/pages/settings/printers.vue")
  },
  {
    name: "forward-zone",
    path: "forward-zone",
    component: () => import("/Users/rice/xtable-pos-v3/modules/setting/pages/settings/forward-zone.vue")
  },
  {
    name: "mobile-connect",
    path: "mobile-connect",
    component: () => import("/Users/rice/xtable-pos-v3/modules/setting/pages/settings/mobile-connect.vue")
  },
  {
    name: "invite-user",
    path: "invite-user",
    component: () => import("/Users/rice/xtable-pos-v3/modules/setting/pages/settings/invite-user.vue")
  },
  {
    name: "receipt-tags",
    path: "receipt-tags",
    component: () => import("/Users/rice/xtable-pos-v3/modules/setting/pages/settings/receipt-tags.vue")
  },
  {
    name: "computer-name",
    path: "computer-name",
    component: () => import("/Users/rice/xtable-pos-v3/modules/setting/pages/settings/computer-name.vue")
  }
]
  },
  {
    name: "topup",
    path: "/topup",
    component: () => import("/Users/rice/xtable-pos-v3/modules/topup/pages/topup.vue"),
    children: [
  {
    name: "",
    path: "",
    component: () => import("/Users/rice/xtable-pos-v3/modules/topup/pages/topup/index.vue")
  },
  {
    name: "",
    path: "promptpay",
    component: () => import("/Users/rice/xtable-pos-v3/modules/topup/pages/topup/promptpay.vue")
  },
  {
    name: "",
    path: "taxInvoiceInfo",
    component: () => import("/Users/rice/xtable-pos-v3/modules/topup/pages/topup/taxInvoiceInfo.vue")
  }
]
  }
]